import { render, staticRenderFns } from "./SectionBlock.vue?vue&type=template&id=071c33ec&"
import script from "./SectionBlock.vue?vue&type=script&lang=js&"
export * from "./SectionBlock.vue?vue&type=script&lang=js&"
import style0 from "./SectionBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports